<mat-radio-group
  [ngModel]="value"
  [ngClass]="justify"
  [class.column]="display === 'column'"
  [required]="required"
  [labelPosition]="labelPosition"
  [disabled]="disabled || readonly"
  (change)="onChange($event.value)"
>
  @for (option of options; track option.value ?? $index) {
    <mat-radio-button
      [class.disabled]="option.readonly || disabled || readonly"
      [class.position-before]="labelPosition === 'before'"
      [value]="option.value"
      [disabled]="option.readonly"
      [disableRipple]="true"
    >
      {{ option.label | translate }}
    </mat-radio-button>
  }
</mat-radio-group>
